<fieldset [attr.id]=" question.id ">
  <legend>
    <div [attr.aria-labelledby]=" question.id +'-err'"></div>
    @let title = text();
    @if (title) {
      <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
    }
  </legend>
  @if (controlHasError()) {
    <div class="alert  alert-danger error pill form-error-list">
      <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
        <ul>
          @for (err of baseForm.errorMap.get(question.id!); track err) {
            <li>
              <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  @if (control) {
    <div class="row">
      <div class="col-12">
        <div [ngClass]="inputClass">
          @for (option of question.orderedAcceptedValues; track $index) {
            <div class="option">

              <label for="{{ question.id }}-{{ convertWhitespaces(option.key!) }}">
                <span class="displayValue">{{ displayValue(option.key!, optionCode(option.key!)) }}</span>
              </label>

              <!-- [note] we need to keep both attr.name and name to handle screen reading, tabbing through groups and handling multiple groups -->
              <input #input type="radio"
                     id="{{ question.id }}-{{ convertWhitespaces(option.key!) }}"
                     [attr.value]="question.id + '###' + option.key" value="{{ question.id + '###' + option.key }}"
                     [attr.name]="nameAttr()" name="{{ nameAttr() }}"
                     [required]="question.required" [attr.aria-required]="question.required"
                     [attr.aria-invalid]="controlHasError()"
                     (change)="revalidateInput()"
                     (keydown.enter)="onEnter($event)"
                     [formControl]="control | asFormControl"
                     [checked]="control.value ===  question.id  + '###' + option.key">
              <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events --> <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
              <span class="checkmark" (click)="selectOption(option.key!)"></span>
              @if (!!control.validator && !isHoriz() && $last && control.touched && !control.pending) {
                <div #feedback class="feedback-icon form-group radio" aria-hidden="true">
                  <i class="fa" aria-hidden="true"
                     [ngClass]="{ 'fa-check-circle' : !controlHasError() && (!question.required || !!getControlValue()), 'fa-times-circle' :  controlHasError() }"></i>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (standalone) {
      <div class="option-row row mt-8 mx-0">
        <div class="mt-4 px-0 text-end">
          <button class="btn primary rounded-pill confirm-button"
                  [disabled]="baseForm.loading || baseForm.preventSave"
                  [attr.aria-label]="getLabel() + '.confirm_button'"
                  (click)="onEnter($event)"
                  (keydown.enter)="onEnter($event)">
            @if (baseForm.loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.save-and-continue') }}
          </button>
        </div>
      </div>
    }
  }

</fieldset>
<ng-content></ng-content>
